// initial state
const state = {
  all: [],
  count: 0,
  news: null,
  ingameNews: ''
}

// getters
const getters = {
  Newslog: state => state.all,
  NewsLogCount: state => state.count,
  News: state => state.news,
  IngameNews: state => state.ingameNews

}

// actions
const actions = {
  getNewslog ({ commit }, trades) {
    commit('setNewslog', trades.data)
  },
  getNews ({ commit }, trades) {
    commit('setNews', trades.data)
  },
  getIngameNews ({ commit }, news) {
    commit('setIngameNews', news.data)
  },
  clearNewslog ({ commit }) {
    commit('clearNewslog')
  }
}

// mutations
const mutations = {
  setNewslog (state, log) {
    state.all = log.entries
    if (log.count > 0) {
      state.count = log.count
    }
  },
  setNews (state, news) {
    state.news = news
  },
  setIngameNews (state, news) {
    state.ingameNews = news
  },
  clearNewslog (state) {
    state.all = []
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
